import React from 'react';

const PACKAGES = [
  {
    id: 1,
    title: 'Frankly Outlets',
    subtitle: 'TV, Radio Media Outlets',
    price: 15,
    features: ['Frankly Outlets'],
    icon: null
  },
  {
    id: 2,
    title: 'USA TODAY Press Release',
    subtitle: "This package provides press release publication on USA TODAY, helping improve your website's search visibility and drive more traffic to your site.",
    price: 250,
    features: ['USA TODAY'],
    icon: null
  },
  {
    id: 3,
    title: 'MSN News Press Release',
    subtitle: 'Get your Press Release published on MSN News with Do-Follow links and Images.',
    price: 200,
    features: ['MSN News'],
    icon: 'msn' // placeholder for logo
  }
];

export default function PRPackages() {
  return (
    <div style={styles.container}>
      <h2 style={styles.pageTitle}>Packages</h2>
      
      <div style={styles.grid}>
        {PACKAGES.map((pkg) => (
          <div key={pkg.id} className="card" style={styles.card}>
            <div style={styles.cardTop}>
              <h3 style={styles.pkgTitle}>{pkg.title}</h3>
              <p style={styles.pkgSubtitle}>{pkg.subtitle}</p>
              <div style={styles.price}>${pkg.price}</div>
            </div>

            <div style={styles.features}>
              {pkg.features.map((f, i) => (
                <div key={i} style={styles.featureItem}>
                  <span style={styles.check}>✓</span> {f} {pkg.icon === 'msn' && <span style={styles.msnLogo}>msn</span>}
                </div>
              ))}
            </div>

            <div style={styles.cardBottom}>
              <div style={styles.priceSmall}>${pkg.price}</div>
              <select style={styles.select}>
                <option>1 Press Release</option>
                <option>2 Press Releases</option>
              </select>
              <button style={styles.btnOutline}>Pay With PayPal</button>
              <button style={styles.btnOutline}>Pay With Crypto</button>
              <button style={styles.btnText}>Add coupon</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '1200px',
  },
  pageTitle: {
    marginBottom: '1.5rem',
    fontSize: '1.25rem',
    color: '#333',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '1.5rem',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    overflow: 'hidden',
  },
  cardTop: {
    padding: '2rem 1.5rem 1.5rem',
    textAlign: 'center',
    borderBottom: '1px solid #e5e7eb',
    minHeight: '160px',
  },
  pkgTitle: {
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#333',
    marginBottom: '0.5rem',
  },
  pkgSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    marginBottom: '1rem',
    lineHeight: 1.4,
  },
  price: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: '#1a62d5',
  },
  features: {
    padding: '1.5rem',
    flex: 1,
    borderBottom: '1px solid #e5e7eb',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.9rem',
    color: '#444',
    marginBottom: '0.5rem',
  },
  check: {
    color: '#10b981',
    fontWeight: 'bold',
  },
  msnLogo: {
    background: '#000',
    color: '#fff',
    padding: '0.1rem 0.3rem',
    borderRadius: '4px',
    fontSize: '0.7rem',
    fontWeight: 800,
    marginLeft: '0.25rem',
  },
  cardBottom: {
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    textAlign: 'center',
  },
  priceSmall: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: '#1a62d5',
    marginBottom: '0.5rem',
  },
  select: {
    padding: '0.5rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
  },
  btnOutline: {
    padding: '0.6rem',
    border: '1px solid #1a62d5',
    background: 'none',
    color: '#1a62d5',
    borderRadius: '4px',
    fontSize: '0.9rem',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  btnText: {
    background: 'none',
    border: 'none',
    color: '#1a62d5',
    fontSize: '0.85rem',
    cursor: 'pointer',
    marginTop: '0.5rem',
  }
};
